<template>
  <div>
    <p>Positionen på din Nexa Bridge hämtas med hjälp av din externa IP-adress. Beroende på vart du bor kan denna antingen vara ganska exakt eller vara fel på några mil, något som i sin tur gör att uträkningen av soluppgång samt solnedgång blir felaktig. Här nedanför har du möjlighet att ändra positionen.</p>
    
    <p>Du kan dra den röda markören till den positionen du vill använda dig av, exempelvis där du bor. Detta kommer att uppdatera positionen samt tiden för soluppgång och solnedgång.</p>
    
    <p>Solen går upp <strong>{{ $root.data.info.sunrise }}</strong> och ner vid <strong>{{ $root.data.info.sunset }}</strong>.</p>
        
    <div style="border:1px solid #d2d2d2;width:100%;height:600px;margin-top:1em;" v-if="Object.keys(location).length">
      <gmap-map ref="map" :center="location" :zoom="14" style="width: 100%; height: 100%;">
        <gmap-marker :position="location" :clickable="true" :draggable="true" @dragend="updateLocationInBridge"></gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import { HTTP } from '../http.js'
  import { eventbus } from '../eventbus.js'
  
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyD2JcbcYQfyrN_Rl5_D2TrOu5Kd59juy_4'
    }
  })

  export default {
    name: 'installningar_template',
    data: () => ({
    }),
    created () {
      // Workaround för att rita om kartan varje gång
      // denna tabben visas av användaren.
      eventbus.$on('tab-change', (tabIndex, newTab, oldTab) => {
        if (tabIndex === 1) {
          Vue.$gmapDefaultResizeBus.$emit('resize')
        }
      })
    },
    computed: {
      location () {
        return {
          lat: this.$root.data.info.location.lat,
          lng: this.$root.data.info.location.lon
        }
      }
    },
    methods: {
      updateLocationInBridge (a) {
        const latitude = a.latLng.lat()
        const longitude = a.latLng.lng()
        
        // Detta kommer att centrera kartan efter 500 ms på den
        // nya positionen som användaren valde.
        setTimeout(() => {
          // Panorera till nya positonen
          this.$refs.map.panTo({
            lat: latitude, 
            lng: longitude
          })
          
          this.$root.data.info.location.lat = latitude
          this.$root.data.info.location.lon = longitude
        }, 300)

        // Skickar de nya koordinaterna till Bridgen och sätter
        // dessa. Det resulterar i att Bridgen försöker hämta nya
        // tiden för soluppgång och nedgång.
        HTTP.post('location', {
          lat: parseFloat(latitude),
          lon: parseFloat(longitude),
          status: 'success'
        })
        .then(res => res.data)
        .then(json => {
          // Eftersom tiden för soluppgång och nedgång ändras när vi ändrar positionen
          // så kommer vi här att hämta /info igen för att kunna uppdatera tiden för detta.
          HTTP.get('info')
          .then(res => res.data)
          .then(json => this.$root.data.info = json)
        })
      }
    },
    destroyed () {
      eventbus.$off('tab-change')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/installningar_position.vue